import TextFieldExtension from "../../@libs/TextFieldExtension";

import emailValidation from "../../validations/email";
import required from "@libs/required";

class EmailTextField extends TextFieldExtension {
	constructor(...args) {
		super(...args);
	}

	get val() {
		return super.val;
	}

	get id() {
		return super.id;
	}

	get name() {
		return super.name;
	}

	get isValid() {
		return super.isValid;
	}

	validate(val = required`val`, customValidation) {
		return super.validate(
			val,
			customValidation || super.validation || emailValidation
		);
	}

	displayError(val = required`val`) {
		super.displayError(val);
	}
}

export default EmailTextField;
